export const isNull = (x:any) => x === null || x === undefined || x === '';